import * as toastsActions from '@zola-helpers/client/dist/es/redux/toasts/toastsActions';
import type {
  WAvailablePersonalizationListView,
  WUserSelectionListView,
  WUserSelectionRequest,
} from '@zola/svc-web-api-ts-client';

import ApiService from '../util/apiService';
import * as ActionType from './types/PersonalizationActionTypes';
import Logger from '../util/logger';
import { AppDispatch } from './types';

const receivedAvailableSkuPersonalization = (
  response: WAvailablePersonalizationListView,
  productName?: string,
  productBrandName?: string
) => ({
  type: ActionType.RECEIVED_AVAILABLE_SKU_PERSONALIZATION,
  data: { response, productName, productBrandName },
});

const receivedCustomizedPersonalization = (customizedInputsData: any) => ({
  type: ActionType.RECEIVED_SAVE_PERASONALIZATION_FORM_DATA,
  payload: customizedInputsData,
});

const receivedUpdateSkuPersonalization = (response: WUserSelectionListView | null) => ({
  type: ActionType.RECEIVED_UPDATE_SKU_PERSONALIZATION,
  payload: response,
});

const receivedResetSkuPersonalization = () => ({
  type: ActionType.RECEIVED_RESET_PERASONALIZATION_FORM_DATA,
});

// eslint-disable-next-line arrow-body-style
const getAvailableSkuPersonalization =
  (skuId: string, productName?: string, productBrandName?: string) => (dispatch: AppDispatch) => {
    return ApiService.get(
      `/web-registry-api/v1/personalization/availabale-personalization/${skuId}`
    ).then((json) =>
      dispatch(receivedAvailableSkuPersonalization(json, productName, productBrandName))
    );
  };

const savePersonalizationFormData = (formData: any) => (dispatch: AppDispatch) => {
  dispatch(receivedCustomizedPersonalization(formData));
};

const removePersonalizationFormData = () => (dispatch: AppDispatch) => {
  dispatch(receivedCustomizedPersonalization(null));
};

const updateSkuPersonalization = (data: WUserSelectionRequest) => (dispatch: AppDispatch) =>
  ApiService.post('/web-registry-api/v1/personalization/save-personalization', data)
    .then((json) => dispatch(receivedUpdateSkuPersonalization(json)))
    .catch((err) => {
      Logger.error(err.message, err);
      dispatch(
        toastsActions.negative({
          headline: 'Unable to preview personalization.',
          dek: 'Please try again in a few minutes.',
        })
      );
    });

const unsetAllSkuPersonalizationData = () => (dispatch: AppDispatch) =>
  dispatch(receivedResetSkuPersonalization());

const clearLastGeneratedPersonalization = () => (dispatch: AppDispatch) =>
  dispatch(receivedUpdateSkuPersonalization(null));

export {
  getAvailableSkuPersonalization,
  savePersonalizationFormData,
  updateSkuPersonalization,
  unsetAllSkuPersonalizationData,
  clearLastGeneratedPersonalization,
  removePersonalizationFormData,
};
